(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured_collection"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        300: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          loop: true
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 15,
        }
      },
    }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-collection"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        300: {
          slidesPerView: 1.5,
          spaceBetween: 20,    
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        }
      },
    }); 

  } catch(e) { console.error(e); }
})();
})();
